import React, { useState, useEffect } from "react";
import { Link } from "@reach/router";
import useGame from "../../hooks/useGame";
import styled from "styled-components";
import background from "../../assets/background.png"

import Multiplayer from "../../applications/Multiplayer/Multiplayer.js";


export default function Rating({ id, ...props }) {
  const game = useGame(id);
  const [gameStatus, setGameStatus] = useState(true);

  const gameComponent = () => {

        return (
          <ShowGameContainer>
          <Multiplayer
          onBack={() => setGameStatus(false)}
          game={game}
          gameType={game.game_type}
        />
        </ShowGameContainer>
        );
  };
    return <div>{gameComponent()}</div>;
}

const ShowGameContainer = styled.div`
  width: 100%;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 2.5em;
  box-sizing: border-box;
  height: 100vh;

  h1 {
    color: #673c8c;
    margin: 0;
    margin-bottom: 0.25em;
    font-size: 4em;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      font-size: 3.5em;
    }
  }

  @media (min-width: 1025px) and (max-width: 1440px) {
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  }
`;


